import { render, staticRenderFns } from "./LinkDsLsHistory.vue?vue&type=template&id=1db22b5b&"
import script from "./LinkDsLsHistory.vue?vue&type=script&lang=js&"
export * from "./LinkDsLsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports